import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { FlashMessagesService } from 'angular2-flash-messages';
import { ActivatedRoute, Router } from '@angular/router';
import { LimiteAdicionalProposalService } from '../../../service/limite-adicional-proposal/limite-adicional-proposal.service';

export interface SendToCtcModel {
	accountClientID: string,
	proposalID: string,
	userProfile?: string,
	target: string;
	proposalCTC: string;
}

@Component({
	selector: 'app-send-la-to-ctc',
	templateUrl: './send-la-to-ctc.component.html',
	styleUrls: ['./send-la-to-ctc.component.scss']
})
export class SendLaToCtcComponent extends DialogComponent<SendToCtcModel, string> implements SendToCtcModel {

	accountClientID: string;
	proposalID: string;
	userProfile: string;
	target: string;
	proposalCTC: string;

	ctc: any = '';
	ctcs: any[] = [];

	constructor(dialogService: DialogService, private router: Router, private flashMessagesService: FlashMessagesService, private limiteAdicionalProposalService: LimiteAdicionalProposalService) {
		super(dialogService);
	}

	ngOnInit() {
		console.log("LOAD SEND TO CTC MODAL");
		this.getCtcByAccountClient(this.accountClientID);
	}

	getCtcByAccountClient(id) {
		console.log("cliente id", id);
		this.limiteAdicionalProposalService.getCtcByAccountClient(id).subscribe(result => {
			if (result.Success) {
				this.ctcs = result.Result;
				if (!this.proposalCTC) {
					if (this.ctcs.length === 1) {
						this.ctc = this.ctcs[0];
					}
				} else {
					for (var key in this.ctcs) {
						var obj = this.ctcs[key];
						if (obj.CodigoSap === this.proposalCTC) {
							this.ctc = obj;
						}
					}
				}
				console.log("getCtcByAccountClient()", result);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	sendProposal(obj) {
		if (this.target === 'ctc') {
			this.sendToCtc(obj);
		} else if (this.target === 'preAnalise') {
			this.sendToPreAnalise(obj);
		} else if (this.target === 'comite') {			
			this.confirm();
		} else {
			this.flashMessagesService.show("Ocorreu um erro ao tentar mover a proposta.", { cssClass: 'alert-danger', timeout: 6000 });
		}
	}

	sendToCtc(obj) {
		// var data = {
		// 	ID: this.proposalID,
		// 	CodigoSap: obj.CodigoSap
		// }

		// this.limiteAdicionalProposalService.sendToCtc(data).subscribe(result => {
		// 	if (result.Success) {
		// 		console.log("Send to CTC", result);
		// 		this.flashMessagesService.show("Proposta enviada ao CTC", { cssClass: 'alert-success', timeout: 6000 });
		// 		this.confirm();
		// 	} else {
		// 		this.close();
		// 		this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
		// 	}
		// }, error => {
		// 	console.log(error);
		// })
	}

	reloadAccountClient() {
		this.confirm();
		this.router.navigateByUrl('/').then(
		() => {
			this.router.navigateByUrl('/conta-cliente/detalhe/' + this.accountClientID);
		});
	}

	sendToPreAnalise(obj) {
		// var data = {
		// 	ID: this.proposalID,
		// 	CodigoSap: obj.CodigoSap
		// }

		// this.limiteAdicionalProposalService.sendPreAnalise(data).subscribe(result => {
		// 	if (result.Success) {
		// 		console.log("Send To Pre Analise: ", result.Result);
		// 		this.flashMessagesService.show("Proposta enviada para Pré Análise", { cssClass: 'alert-success', timeout: 6000 });
		// 		this.confirm();
		// 	} else {
		// 		this.close();
		// 		this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
		// 	}
		// }, error => {
		// 	console.log(error);
		// 	return false;
		// });
	}

	confirm() {
		this.result = this.ctc.CodigoSap;
		this.close();
	}
}



// WEBPACK FOOTER //
// ./src/app/limite-adicional-proposal/component/actions/send-la-to-ctc/send-la-to-ctc.component.ts